/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export type OpenAPISchema = {
  openapi: string;
  info: {
    title: string;
    version: string;
  };
  paths: {
    [path: string]: {
      [method: string]: {
        operationId?: string;
        description?: string;
        responses?: {
          [statusCode: string]: {
            description?: string;
            content?: unknown;
          };
        };
      };
    };
  };
};

/**
 * Hook to fetch the OpenAPI schema from the management plane API
 *
 * @returns React Query result containing the OpenAPI schema
 */
export function useApiSchemaQuery() {
  return useQuery<OpenAPISchema>({
    queryKey: ['apiSchema'],
    queryFn: async () => {
      const response = await axios.get<OpenAPISchema>(`${window.mimicConfig.MIMIC_MGMT_PLANE_API}/api/schema`, {
        withCredentials: true,
      });
      return response.data;
    },
    staleTime: 1000 * 60 * 60, // Cache for 1 hour
    gcTime: 1000 * 60 * 60 * 24, // Keep in cache for 24 hours
  });
}
